/**
 * Image Background Wrapper - Reposition to cover Section and apply parallax effect
 */
(function () {
  'use strict';

  function repositionImageBackgrounds() {
    const imageBackgrounds = document.querySelectorAll('.x-bg-image');

    imageBackgrounds.forEach((bgElement) => {
      // Skip if already repositioned
      if (bgElement.dataset.repositioned === 'true') {
        return;
      }

      // Find the parent section
      let section = bgElement.closest('.vc_section');

      if (!section) {
        // If no section found, try to find the closest parent that might be a section
        let parent = bgElement.parentElement;
        while (parent && !parent.classList.contains('vc_section')) {
          parent = parent.parentElement;
          if (!parent || parent.tagName === 'BODY') {
            return; // No section found
          }
        }
        section = parent;
      }

      if (section) {
        // Move the image background to be the first child of the section
        // This ensures it covers the entire section
        section.insertBefore(bgElement, section.firstChild);
        bgElement.dataset.repositioned = 'true';
        bgElement.classList.add('x-bg-repositioned');
      }
    });
  }

  function initParallaxEffect() {
    const parallaxLayers = document.querySelectorAll(
      '.x-bg-layer-lower-image[data-x-element-bg-layer]'
    );

    parallaxLayers.forEach((layer) => {
      // Skip if already initialized
      if (layer.dataset.parallaxInitialized === 'true') {
        return;
      }

      try {
        // Get and decode the JSON (handle HTML entities)
        let parallaxDataStr = layer.getAttribute('data-x-element-bg-layer');
        // Decode HTML entities if present
        if (parallaxDataStr.includes('&quot;')) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = parallaxDataStr;
          parallaxDataStr = tempDiv.textContent || tempDiv.innerText || parallaxDataStr;
        }

        const parallaxData = JSON.parse(parallaxDataStr);
        const parallaxSize = parallaxData.parallaxSize || '150%';
        const parallaxDir = parallaxData.parallaxDir || 'v';
        const parallaxRev = parallaxData.parallaxRev || false;

        // Set initial styles - ensure layer is visible
        layer.style.height = parallaxSize;
        layer.style.top = 'auto';
        layer.style.bottom = '0';
        layer.style.opacity = '1';

        // Find the section this layer belongs to
        const section = layer.closest('.vc_section');
        if (!section) {
          return;
        }

        // Parallax update function (using const arrow function to avoid no-inner-declarations)
        const updateParallax = () => {
          if (!section) return;

          const scrollY = window.pageYOffset || window.scrollY || document.documentElement.scrollTop;
          const sectionOffset = section.offsetTop;

          // Calculate transform based on direction
          let translateX = 0;
          let translateY = 0;

          // Calculate maximum translation based on parallax size
          const sizePercent = parseFloat(parallaxSize);
          const extraSize = sizePercent - 100; // How much extra size (e.g., 50% for 150%)

          // If parallaxSize is 100% or less, there's no parallax effect possible
          if (extraSize <= 0) {
            layer.style.transform = `translate3d(0px, 0px, 0px)`;
            return;
          }

          // Calculate how much the section has scrolled relative to viewport
          // As section scrolls up, we want the background to move down (positive Y)
          // This creates the parallax effect where background moves slower
          const scrollDistance = scrollY - sectionOffset;

          // Parallax speed factor: how much slower the background moves
          // For 150% size, we can move 50% of the scroll distance
          const parallaxSpeed = extraSize / 100; // 0.5 for 150%, 1.0 for 200%, etc.

          // Calculate translation: move background proportionally to scroll
          // As you scroll down (scrollDistance increases), background moves up (negative Y)
          const translateAmount = scrollDistance * parallaxSpeed;

          if (parallaxDir === 'v') {
            // Vertical parallax
            // Negative Y moves the image up as we scroll down
            translateY = -translateAmount;
            if (parallaxRev) {
              translateY = -translateY;
            }
          } else {
            // Horizontal parallax
            translateX = -translateAmount;
            if (parallaxRev) {
              translateX = -translateX;
            }
          }

          // Apply transform
          layer.style.transform = `translate3d(${translateX}px, ${translateY}px, 0px)`;
        };

        // Initial update
        updateParallax();

        // Update on scroll (using const arrow function to avoid no-inner-declarations)
        let ticking = false;
        const onScroll = () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              updateParallax();
              ticking = false;
            });
            ticking = true;
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', updateParallax, { passive: true });

        // Mark as initialized
        layer.dataset.parallaxInitialized = 'true';
      } catch (error) {
        console.warn('Error initializing parallax:', error);
        // Fallback: set default styles even if JSON parsing fails
        layer.style.height = '150%';
        layer.style.top = 'auto';
        layer.style.bottom = '0';
        layer.style.opacity = '1';
        layer.dataset.parallaxInitialized = 'true';
      }
    });
  }

  function initImageBackgroundWrapper() {
    // First, reposition all image backgrounds to cover their sections
    repositionImageBackgrounds();

    // Then initialize parallax effects
    setTimeout(() => {
      initParallaxEffect();
    }, 50);
  }

  // Initialize when DOM is ready
  if (
    document.readyState === 'loading' ||
    document.readyState === 'interactive'
  ) {
    document.addEventListener('DOMContentLoaded', function () {
      initImageBackgroundWrapper();
      // Also reposition after a short delay to handle dynamic content
      setTimeout(repositionImageBackgrounds, 100);
      setTimeout(initParallaxEffect, 150);
    });
  } else {
    // DOM is already ready
    initImageBackgroundWrapper();
    setTimeout(repositionImageBackgrounds, 100);
    setTimeout(initParallaxEffect, 150);
  }

  // Re-initialize for dynamically loaded content (e.g., AJAX)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('vc_reload', function () {
      // Reset repositioned flag on reload
      document.querySelectorAll('.x-bg-image').forEach((el) => {
        el.dataset.repositioned = 'false';
      });
      document.querySelectorAll('.x-bg-layer-lower-image').forEach((el) => {
        el.dataset.parallaxInitialized = 'false';
      });
      initImageBackgroundWrapper();
      setTimeout(repositionImageBackgrounds, 100);
      setTimeout(initParallaxEffect, 150);
    });
  }

  // Also run on window load to catch any late-loading content
  window.addEventListener('load', function () {
    setTimeout(repositionImageBackgrounds, 100);
    setTimeout(initParallaxEffect, 150);
  });
})();

